var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryGt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_9161)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_9161",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_9161)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.6665,
    width: 9.33333,
    height: 20,
    fill: "#63AEE3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H9.33333V0H0V20Z",
    fill: "#63AEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 9.33325C12.0002 8.96506 11.7017 8.66659 11.3335 8.66659C10.9653 8.66659 10.6668 8.96506 10.6668 9.33325H12.0002ZM12.3292 12.218C12.6477 12.4028 13.0556 12.2944 13.2404 11.976C13.4252 11.6575 13.3168 11.2496 12.9984 11.0648L12.3292 12.218ZM15.0758 11.0198C14.7656 11.2181 14.675 11.6304 14.8734 11.9406C15.0718 12.2508 15.484 12.3414 15.7942 12.143L15.0758 11.0198ZM17.3335 9.33325C17.3335 8.96506 17.035 8.66659 16.6668 8.66659C16.2986 8.66659 16.0002 8.96506 16.0002 9.33325H17.3335ZM10.6668 9.33325C10.6668 10.5663 11.3367 11.6421 12.3292 12.218L12.9984 11.0648C12.4001 10.7176 12.0002 10.0718 12.0002 9.33325H10.6668ZM15.7942 12.143C16.7184 11.5519 17.3335 10.5146 17.3335 9.33325H16.0002C16.0002 10.0409 15.6331 10.6633 15.0758 11.0198L15.7942 12.143Z",
    fill: "#628A40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 10.6667C14.7362 10.6667 15.3332 10.0697 15.3332 9.33333C15.3332 8.59695 14.7362 8 13.9998 8C13.2635 8 12.6665 8.59695 12.6665 9.33333C12.6665 10.0697 13.2635 10.6667 13.9998 10.6667Z",
    fill: "#DCC26D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_9161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryGt);
export default __webpack_public_path__ + "static/media/Country=GT.f8db32326a738dcbc8a42391f377204d.svg";
export { ForwardRef as ReactComponent };